var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-sidebar",
    {
      ref: "sidebar_fields",
      attrs: {
        id: _vm.sidebarFields,
        "sidebar-class": "custom-sidebar-container sidebar-fields",
        title: "Настройка колонок",
        right: "",
        shadow: "",
        backdrop: ""
      }
    },
    [
      _c("div", { staticClass: "d-flex flex-column h-100" }, [
        _c(
          "div",
          { staticClass: "flex-grow-1 overflow-auto p-3" },
          [
            _c(
              "draggable",
              {
                attrs: { handle: ".drag-handle" },
                model: {
                  value: _vm.localFields,
                  callback: function($$v) {
                    _vm.localFields = $$v
                  },
                  expression: "localFields"
                }
              },
              _vm._l(_vm.localFields, function(field) {
                return _c("div", { key: field.id }, [
                  field.isSeparator
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "font-weight-bold text-small text-muted text-uppercase p-2 my-1"
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(field.label) +
                              "\n          "
                          )
                        ]
                      )
                    : _c("div", { staticClass: "export-list-item" }, [
                        _c(
                          "div",
                          {
                            staticClass:
                              "d-flex align-items-center text-truncate"
                          },
                          [
                            _c(
                              "span",
                              { staticClass: "drag-handle text-dark mr-3" },
                              [
                                _c("v-icon", {
                                  attrs: { name: "buttons/dots", size: 12 }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("span", { staticClass: "text-small" }, [
                              _vm._v(_vm._s(field.label))
                            ]),
                            _vm._v(" "),
                            _vm.configureRequired &&
                            field.required &&
                            field.visible
                              ? _c(
                                  "span",
                                  {
                                    staticClass:
                                      "text-danger font-weight-bold ml-2"
                                  },
                                  [_vm._v("*")]
                                )
                              : _vm._e()
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "d-flex align-items-center",
                            staticStyle: { gap: "12px" }
                          },
                          [
                            _vm.configureRequired
                              ? _c("b-form-checkbox", {
                                  staticClass: "m-0",
                                  attrs: {
                                    disabled: !field.visible,
                                    title: "Обязательное поле"
                                  },
                                  model: {
                                    value: field.required,
                                    callback: function($$v) {
                                      _vm.$set(field, "required", $$v)
                                    },
                                    expression: "field.required"
                                  }
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "ant-switch-wrapper" },
                              [
                                _c("b-form-checkbox", {
                                  staticClass: "m-0",
                                  attrs: {
                                    disabled:
                                      _vm.visibleFields.length === 1 &&
                                      field.visible,
                                    switch: ""
                                  },
                                  model: {
                                    value: field.visible,
                                    callback: function($$v) {
                                      _vm.$set(field, "visible", $$v)
                                    },
                                    expression: "field.visible"
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "switch-icons-overlay" },
                                  [
                                    _c("v-icon", {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: field.visible,
                                          expression: "field.visible"
                                        }
                                      ],
                                      staticClass: "ml-2",
                                      staticStyle: { color: "#fff" },
                                      attrs: { name: "buttons/check", size: 11 }
                                    }),
                                    _vm._v(" "),
                                    _c("span", {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: !field.visible,
                                          expression: "!field.visible"
                                        }
                                      ],
                                      staticClass: "flex-grow-1"
                                    }),
                                    _vm._v(" "),
                                    _c("v-icon", {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: !field.visible,
                                          expression: "!field.visible"
                                        }
                                      ],
                                      staticClass: "mr-2",
                                      staticStyle: { color: "#fff" },
                                      attrs: { name: "buttons/cross", size: 10 }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ])
                ])
              }),
              0
            )
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "export-sidebar-footer px-3 py-3 border-top" },
          [
            _c(
              "div",
              {
                staticClass: "d-flex flex-wrap align-items-center",
                staticStyle: { gap: "12px" }
              },
              [
                _c(
                  "b-button",
                  {
                    staticClass: "text-small p-0",
                    staticStyle: {
                      color: "#F5222D !important",
                      "text-decoration": "none !important"
                    },
                    attrs: { variant: "link" },
                    on: { click: _vm.resetColumns }
                  },
                  [_vm._v("\n          Сбросить\n        ")]
                ),
                _vm._v(" "),
                _vm.checkAll
                  ? _c(
                      "b-button",
                      {
                        staticClass: "text-small text-dark p-0",
                        staticStyle: {
                          "text-decoration": "none !important",
                          color: "#6c757d"
                        },
                        attrs: { variant: "link" },
                        on: {
                          click: function($event) {
                            return _vm.checkAllColumns(false)
                          }
                        }
                      },
                      [
                        _c("v-icon", {
                          staticClass: "mr-1 pt-1",
                          attrs: { name: "buttons/toggle_left", size: 15 }
                        }),
                        _vm._v(" Снять все\n        ")
                      ],
                      1
                    )
                  : _c(
                      "b-button",
                      {
                        staticClass: "text-small text-dark p-0",
                        staticStyle: { "text-decoration": "none !important" },
                        attrs: { variant: "link" },
                        on: {
                          click: function($event) {
                            return _vm.checkAllColumns(true)
                          }
                        }
                      },
                      [
                        _c("v-icon", {
                          staticClass: "mr-1 pt-1",
                          attrs: { name: "buttons/toggle_right", size: 15 }
                        }),
                        _vm._v(" Выбрать все\n        ")
                      ],
                      1
                    ),
                _vm._v(" "),
                _c(
                  "b-button",
                  {
                    staticClass: "custom-btn-primary ml-auto",
                    on: {
                      click: function($event) {
                        return _vm.saveColumns(false)
                      }
                    }
                  },
                  [
                    _c("v-icon", {
                      staticClass: "mr-1",
                      attrs: { name: "buttons/save", size: 13 }
                    }),
                    _vm._v(" Сохранить\n        ")
                  ],
                  1
                )
              ],
              1
            )
          ]
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1ca1fe42", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1ca1fe42","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/utilites/commonUi/DynamicTables.vue
// module id = null
// module chunks = 